import { ActionTypes } from '../actions';

const defaultDiversityvc = {
    score: {},
    benchmark: {},
    goals: [],
    pdf_url: {},
};


export default (diversityvc= defaultDiversityvc, action) => {
    try {
        switch(action.type) {
            case ActionTypes.LOADED_DIVERSITYVC_PDF:{
                const pdf_url = {...diversityvc.pdf_url, ...action.payload};
                return {
                    ...diversityvc,
                    pdf_url
                };
            }
            case ActionTypes.CLEAR_DIVERSITYVC_PDF:{
                const pdf_url = {};
                return {
                    ...diversityvc,
                    pdf_url
                };
            }
            case ActionTypes.LOADED_DIVERSITYVC_COMPANY_POLICY:{
                const company_policy = {...diversityvc.company_policy, ...action.payload};
                return {
                    ...diversityvc,
                    company_policy
                };
            }
            case ActionTypes.LOADED_DIVERSITYVC_POLICY:{
                const policy = {...diversityvc.policy, ...action.payload};
                return {
                    ...diversityvc,
                    policy
                };
            }
            case ActionTypes.LOADED_DIVERSITYVC_SCORE:{
                const score = {...diversityvc.score, ...action.payload};
                return {
                    ...diversityvc,
                    score
                };
            }
            case ActionTypes.LOADED_DIVERSITYVC_BENCHMARK:{
                const benchmark = {...diversityvc.benchmark, ...action.payload};
                return {
                    ...diversityvc,
                    benchmark
                };
            }
            case ActionTypes.LOADED_DIVERSITYVC_RESOURCE:{
                const resource = action.payload;
                return Object.assign({},diversityvc,{resource})
            }
            case ActionTypes.FAILED_LOADING_DIVERSITYVC_RESOURCE:{
                const resource = [];
                return Object.assign({},diversityvc,{resource})
            }
            case ActionTypes.LOADED_DIVERSITYVC_GOAL: {
                const goals = action.payload;
                return Object.assign({},diversityvc,{goals})
            }
            case ActionTypes.DONE_SIGNOUT:
                return {
                    ...defaultDiversityvc
                }
            default:
                return diversityvc;
        }
    } catch(error) {
        console.error(`Error in appState reducer: ${ error.message || error.code || error }`, error);
        return diversityvc
    }
};
